/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2469
 */

var /* [auto-meaningful-name] */Object$prototype$toString = Object.prototype.toString
module.exports = function (e) {
  return Object$prototype$toString.call(e)
}
